import React, { useState } from 'react';
import { FooterBarItem } from '../../../components/cash-register/footer-bar/footer-bar-item';
import { useT } from '../../../utils/helper';
import { ModalCreateTipInvoice } from '../../../components/cash-register/modals/modal-create-tip-invoice';

enum ModalVisible {
  CreateTipInvoice,
  None,
}

export const CreateTipInvoiceButton = () => {
  // Standard Hooks
  const t = useT('screens', { keyPrefix: 'InvoiceList' });
  // States
  const [modalVisible, setModalVisible] = useState<ModalVisible>(
    ModalVisible.None,
  );

  return (
    <>
      <FooterBarItem
        active={true}
        disabled={false}
        text={t('createTipInvoice')}
        onPress={() => setModalVisible(ModalVisible.CreateTipInvoice)}
      />

      <ModalCreateTipInvoice
        isVisible={modalVisible === ModalVisible.CreateTipInvoice}
        content={t('createTipInvoice')}
        onModalHide={() => setModalVisible(ModalVisible.None)}
      />
    </>
  );
};
